import type { Product } from '@/types/product';

const CATEGORY_PRIORITY=['engagement','earrings','necklaces','bracelets','wedding','rings','gemstones','pearls','ready'];

const categories=(p:Product)=>[...new Set([p.category,...(p.categoryKeys||[])].filter(Boolean))];
const imageKey=(p:Product)=>(p.image||p.gallery?.[0]||'').split('?')[0].trim().toLowerCase();

function productScore(p:Product){
 let score=0;
 if(p.featured)score+=100;
 if(p.oldPrice>p.price)score+=8;
 if(p.readyToShip)score+=5;
 if((p.gallery||[]).length>1)score+=3;
 if(p.source==='diamka')score+=1;
 return score;
}

export function pickDiverseCuratedProducts(products:Product[],limit=8){
 const ranked=[...products]
  .filter(p=>p.status==='active'&&p.price>0&&Boolean(p.image||p.gallery?.[0]))
  .sort((a,b)=>productScore(b)-productScore(a)||Number(a.id)-Number(b.id));

 const chosen:Product[]=[];
 const ids=new Set<number>();
 const images=new Set<string>();
 const subcategories=new Set<string>();
 const shapes=new Set<string>();

 const take=(p?:Product)=>{
  if(!p||ids.has(p.id))return false;
  const img=imageKey(p);
  if(img&&images.has(img))return false;
  chosen.push(p);ids.add(p.id);if(img)images.add(img);
  if(p.subcategory)subcategories.add(p.subcategory.toLowerCase());
  if(p.shape)shapes.add(p.shape.toLowerCase());
  return true;
 };

 for(const category of CATEGORY_PRIORITY){
  if(chosen.length>=limit)break;
  const pool=ranked.filter(p=>categories(p).includes(category));
  const diverse=pool.find(p=>{
   const sub=(p.subcategory||'').toLowerCase();
   const shape=(p.shape||'').toLowerCase();
   return !images.has(imageKey(p))&&(!sub||!subcategories.has(sub))&&(!shape||!shapes.has(shape));
  });
  take(diverse||pool.find(p=>!images.has(imageKey(p))));
 }

 for(const p of ranked){if(chosen.length>=limit)break;take(p)}
 return chosen.slice(0,limit);
}
